import { createSelector } from 'reselect'

const getAccessControl = (state) => state.accessControl || {}
const getBpDetails     = (state) => state.bpDetails    || {}

export const selectSelectedBp = createSelector(
  getBpDetails,
  (s) => s.selectedBp || null
)

export const selectSelectedBpId = createSelector(
  selectSelectedBp,
  (bp) => (bp && (bp.id || bp.bpId || bp.uuid)) || null
)

const arr = (v) => (Array.isArray(v) ? v : [])

export const selectInvitationsList = (state, bpIdArg) => {
  const bpId = bpIdArg ?? selectSelectedBpId(state)
  const ac   = getAccessControl(state)
  const bpd  = getBpDetails(state)

  const fromAC =
    ac.byBuildingPassport?.[bpId]?.invitations ??
    ac.data?.[bpId]?.invitations ??
    ac.invitations?.[bpId] ??
    ac.invitations ?? null

  if (Array.isArray(fromAC)) return fromAC

  const fromBP =
    bpd.selectedBp?.invitations ??
    bpd.selectedBp?.invites ??
    bpd.selectedBp?.access?.invitations ??
    bpd.invitations ??
    null

  return arr(fromBP)
}

export const selectInvitationsCount = (state, bpId) =>
  selectInvitationsList(state, bpId).length

export const selectRequestsList = (state, bpIdArg) => {
  const bpId = bpIdArg ?? selectSelectedBpId(state)
  const ac   = getAccessControl(state)
  const bpd  = getBpDetails(state)

  const fromAC =
    ac.byBuildingPassport?.[bpId]?.requests ??
    ac.data?.[bpId]?.requests ??
    ac.requests?.[bpId] ??
    ac.requests ?? null

  if (Array.isArray(fromAC)) return fromAC

  const fromBP =
    bpd.selectedBp?.requests ??
    bpd.selectedBp?.accessRequests ??
    bpd.requests ??
    null

  return arr(fromBP)
}

export const selectRequestsCount = (state, bpId) =>
  selectRequestsList(state, bpId).length

export const selectRevokedList = (state, bpIdArg) => {
  const bpId = bpIdArg ?? selectSelectedBpId(state)
  const ac   = getAccessControl(state)
  const bpd  = getBpDetails(state)

  const fromAC =
    ac.byBuildingPassport?.[bpId]?.revoked ??
    ac.data?.[bpId]?.revoked ??
    ac.revoked?.[bpId] ??
    ac.revoked ?? null

  if (Array.isArray(fromAC)) return fromAC

  const fromBP =
    bpd.selectedBp?.revoked ??
    bpd.selectedBp?.revokedUsers ??
    bpd.revoked ??
    null

  return arr(fromBP)
}

export const selectRevokedCount = (state, bpId) =>
  selectRevokedList(state, bpId).length
